function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';

const SvgComponent = ({
  enabled,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 15 15",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.891 1.154c.178-.609 1.04-.609 1.218 0a1.234 1.234 0 002.037.546c.458-.438 1.205-.008 1.054.608-.22.9.593 1.711 1.492 1.492.616-.15 1.046.596.608 1.054a1.234 1.234 0 00.546 2.037c.609.178.609 1.04 0 1.218a1.234 1.234 0 00-.546 2.037c.438.458.008 1.205-.608 1.054-.9-.22-1.711.593-1.492 1.492.15.616-.596 1.046-1.054.608a1.234 1.234 0 00-2.037.546c-.178.609-1.04.609-1.218 0a1.234 1.234 0 00-2.037-.546c-.458.438-1.205.008-1.054-.608.22-.9-.593-1.711-1.492-1.492-.616.15-1.046-.596-.608-1.054a1.234 1.234 0 00-.546-2.037c-.609-.178-.609-1.04 0-1.218A1.234 1.234 0 001.7 4.854c-.438-.458-.008-1.205.608-1.054.9.22 1.711-.593 1.492-1.492-.15-.616.596-1.046 1.054-.608.669.64 1.778.342 2.037-.546z",
  fill: enabled ? '#DAF0ED' : 'none',
  stroke: "#828A90"
}));

export default SvgComponent;